var React = require('react');

function ArrowAltFromTop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 56v16a23.94 23.94 0 0 1-24 24H24A23.94 23.94 0 0 1 0 72V56a23.94 23.94 0 0 1 24-24h336a23.94 23.94 0 0 1 24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M151.89 128H232a24 24 0 0 1 24 24v136h88c17.82 0 26.73 21.51 14.12 34.11L205.67 474.37a19.4 19.4 0 0 1-27.34 0L25.91 322.14C13.3 309.54 22.21 288 40 288h87.83V152a24 24 0 0 1 24.06-24z","className":"fa-primary","key":2})]);
}

ArrowAltFromTop.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = ArrowAltFromTop;

ArrowAltFromTop.default = ArrowAltFromTop;
